import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const refCache = {};
export const useRefOptions = (refKey) => {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    if (!refKey) return;
    if (!refCache[refKey]) refCache[refKey] = api.get(`/m/${refKey}`).then((r) => r.data);
    refCache[refKey].then(setOpts).catch(() => { delete refCache[refKey]; });
  }, [refKey]);
  return opts;
};
export const invalidateRef = (key) => { delete refCache[key]; };

const C = "h-8 text-xs";

const SelectField = ({ value, onChange, options, testId }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger className={C} data-testid={testId}><SelectValue placeholder="Select..." /></SelectTrigger>
    <SelectContent>
      {options.map((o) => <SelectItem key={o} value={o} className="text-xs">{o}</SelectItem>)}
    </SelectContent>
  </Select>
);

const RefField = ({ field, value, onChange, testId }) => {
  const opts = useRefOptions(field.ref);
  const names = opts.map((o) => o[field.ref_label || "name"]).filter(Boolean);
  if (value && !names.includes(value)) names.unshift(value);
  return <SelectField value={value} onChange={onChange} options={names} testId={testId} />;
};

const INPUT_TYPES = { number: "number", currency: "number", date: "date", datetime: "datetime-local", month: "month", email: "email" };

export const FieldInput = ({ field, value, onChange }) => {
  const testId = `input-${field.name}`;
  if (field.type === "select") return <SelectField value={value} onChange={onChange} options={field.options} testId={testId} />;
  if (field.type === "ref") return <RefField field={field} value={value} onChange={onChange} testId={testId} />;
  if (field.type === "boolean") return <div className="flex h-8 items-center"><Switch data-testid={testId} checked={!!value} onCheckedChange={onChange} /></div>;
  if (field.type === "textarea") return <Textarea data-testid={testId} className="min-h-[52px] text-xs" value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={2} />;
  return (
    <Input
      data-testid={testId}
      className={C}
      type={INPUT_TYPES[field.type] || "text"}
      step="any"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
